"use client"

import type React from "react"

import { useEffect } from "react"

interface UseNotificationEffectsProps {
  notifications: any
  updateUsersWithHistory: React.Dispatch<React.SetStateAction<Set<string>>>
}

export const useNotificationEffects = ({ notifications, updateUsersWithHistory }: UseNotificationEffectsProps) => {
  useEffect(() => {
    const userIdsWithActiveNotifications = new Set<number>()
    Object.keys(notifications.messages).forEach((id) => userIdsWithActiveNotifications.add(Number(id)))
    Object.keys(notifications.transfers).forEach((id) => userIdsWithActiveNotifications.add(Number(id)))

    updateUsersWithHistory((prev) => {
      const updated = new Set(prev)
      userIdsWithActiveNotifications.forEach((id) => {
        updated.delete(String(id))
      })
      return updated
    })
  }, [notifications, updateUsersWithHistory])
}
